import i18n from '@/main';

function tradutorDeLaudos(nome) {
    const laudosTraduzidos = {
        Agrícola: i18n.t('mensagens.laudos.nomes.1'),
        'Bacen - Fiscalização Remota': i18n.t('mensagens.laudos.nomes.2'),
        Benfeitorias: i18n.t('mensagens.laudos.nomes.3'),
        'Conformidade Ambiental do CAR': i18n.t('mensagens.laudos.nomes.4'),
        Carbono: i18n.t('mensagens.laudos.nomes.5'),
        'Histórico Agrícola': i18n.t('mensagens.laudos.nomes.6'),
        'Diagnóstico Agrícola': i18n.t('mensagens.laudos.nomes.7'),
        'Supressão Vegetal': i18n.t('mensagens.laudos.nomes.8'),
        'Técnico Agrícola': i18n.t('mensagens.laudos.nomes.9'),
        'Croqui de localização': i18n.t('mensagens.laudos.nomes.10'),
        'Bacen Resolução 140': i18n.t('mensagens.laudos.nomes.11'),
        'Avaliação Fundiária': i18n.t('mensagens.laudos.nomes.12'),
        'Avaliação de Área Produtiva': i18n.t('mensagens.laudos.nomes.13'),
        'Avaliação Socioambiental': i18n.t('mensagens.laudos.nomes.14'),
        'Elegibilidade Renovabio': i18n.t('mensagens.laudos.nomes.15')
    };

    return laudosTraduzidos[nome] || nome;
}

export default {
    traduzirLaudo(nome) {
        return tradutorDeLaudos(nome);
    }
};
